import React, { Component } from 'react';
import { Tab } from '.';

import styles from './styles.less';

interface Props {
	children: React.ReactNode;
	selectedTabName: string;
	styles: { bar: string };
	onChange(tabName: string): void;
}

export default class TabBar extends Component<Props> {
	static defaultProps = {
		styles,
	};

	render() {
		const { children, selectedTabName, styles, onChange } = this.props;

		return (
			<ul className={styles.bar}>
				{React.Children.map(children as React.ReactElement, (tab: React.ReactElement<Tab['props']> | null) =>
					tab
						? React.cloneElement(tab, {
								key: tab.props.name,
								isSelected: selectedTabName === tab.props.name,
								onClick: () => onChange(tab.props.name),
						  })
						: null
				)}
			</ul>
		);
	}
}
